import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/900.css";
import "@fontsource/montserrat";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "react-datepicker/dist/react-datepicker.css";

import "./sentry";
import ReactDOM from "react-dom/client";
import { createClient } from "@supabase/supabase-js";

import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { SUPABASE_PUBLIC_KEY, SUPABASE_URL } from "utils/constants";
import { TenantProvider } from "modules/tenant/providers/tenant-provider";
import theme from "theme";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";

import { ChakraProvider } from "@chakra-ui/react";
import { AlertsProvider } from "providers/alerts";
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

library.add(fal);
library.add(far);
library.add(fas);

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLIC_KEY);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

declare global {
  interface Window {
    analytics: any;
  }
}

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <ChakraProvider theme={theme}>
      <AlertsProvider>
        <Router>
          <TenantProvider>
            <App />
          </TenantProvider>
        </Router>
      </AlertsProvider>
    </ChakraProvider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
